import * as R from 'ramda';
import proxyRequest from 'js/proxy_api_client';

/**
 * @typedef {{user_id: number}} UserProfilePatch
 */
const UserProfileApiClient = {
    /**
     * @param {UserProfilePatch} patch
     * @return {Promise<any>}
     */
    async patchProfile(patch) {
        const response = await proxyRequest('patch', 'api/v1/user_profiles', {data: patch});

        return R.prop('data', response);
    }
};

export default UserProfileApiClient;



// WEBPACK FOOTER //
// ./creator/user_profile_api_client/index.js